exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-profile{background-color:#fff}@media(min-width: 1160px){.user-profile__wrap{padding-top:40px}.user-profile__wrap::after{display:table;content:\"\";clear:both}}.user-profile__tabs-container{min-height:calc(100vh - 360px)}.user-profile__tabs-container .block:first-child{margin-top:40px}@media(min-width: 1160px){.user-profile__tabs-container{float:left;min-height:calc(100vh - 230px);-ms-flex-order:-1;order:-1;padding-top:0;padding-right:32px}.user-profile__tabs-container .block:first-child{margin-top:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??postcss!./node_modules/sass-loader/dist/cjs.js!./src/routes/main/userprofile/style.scss
// module id = 1545
// module chunks = 57